/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youcanaddimageslaterfromthelistingdetailspage9Inputs */

const en_youcanaddimageslaterfromthelistingdetailspage9 = /** @type {(inputs: Youcanaddimageslaterfromthelistingdetailspage9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can add images later from the listing details page.`)
};

const de_youcanaddimageslaterfromthelistingdetailspage9 = /** @type {(inputs: Youcanaddimageslaterfromthelistingdetailspage9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder kannst du später auf der Seite des Orts hinzufügen.`)
};

/**
* | output |
* | --- |
* | "You can add images later from the listing details page." |
*
* @param {Youcanaddimageslaterfromthelistingdetailspage9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youcanaddimageslaterfromthelistingdetailspage9 = /** @type {((inputs?: Youcanaddimageslaterfromthelistingdetailspage9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youcanaddimageslaterfromthelistingdetailspage9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youcanaddimageslaterfromthelistingdetailspage9(inputs)
	return de_youcanaddimageslaterfromthelistingdetailspage9(inputs)
});
export { youcanaddimageslaterfromthelistingdetailspage9 as "youCanAddImagesLaterFromTheListingDetailsPage" }